export default __webpack_public_path__ + "static/media/pin_dropoff.5c07ef5c.svg";